import { render } from "./outstore.vue?vue&type=template&id=31b512e8"
import script from "./outstore.vue?vue&type=script&lang=js"
export * from "./outstore.vue?vue&type=script&lang=js"

import "./outstore.vue?vue&type=style&index=0&id=31b512e8&lang=less"

import exportComponent from "D:\\Kaung\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__